import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { L } from '../../../lib/i18n';
import { client } from '../../../lib/trpc';
import { projectQueryKeys } from './useGetProject';

const removeMembership = async (variables: { membershipId: number }) => {
    return client.MembershipsApi.removeMembership.mutate(variables);
};

const useRemoveMembership = () => {
    const queryClient = useQueryClient();
    return useMutation((variables: { membershipId: number; name: string }) => removeMembership(variables), {
        onSuccess: (data, variables, context) => {
            toast.success(`${L('remove_membership_success')} ${variables.name}`);
        },
        onError: (err) => {
            /* Shows error message */
            const error = typeof err === 'string' ? err : new Error(L('reset_error')).message;
            const message = error;
            toast.error(`${L(message)}`);
        },
        onSettled: () => {
            queryClient.invalidateQueries(projectQueryKeys.lists());
        },
    });
};

export default useRemoveMembership;
